export default __webpack_public_path__ + "static/media/transcribe_slide_1.34bfbd6f.png";